import { ToggleButton } from "../../common/ui/toggleSwitch";

interface PaymentFailedNoticeCardProps {
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export const PaymentFailedNoticeCard = ({
  enabled,
  onToggle,
}: PaymentFailedNoticeCardProps) => (
  <div className="flex items-center justify-between gap-4 p-4 bg-global-overlay-secondary rounded-lg border border-global-secondary">
    <div className="min-w-0 space-y-1">
      <label
        htmlFor="paymentFailedNotice"
        className="block text-size-sm font-semibold text-global-primary cursor-pointer"
      >
        Aviso de cobro rechazado
      </label>
      <p className="text-size-2xs text-global-secondary">
        Cuando falla el cobro automático de una suscripción, le llega un correo
        al socio. Se envía una vez por período, en el primer rechazo.
      </p>
    </div>
    <ToggleButton
      id="paymentFailedNotice"
      checked={enabled}
      onToggle={onToggle}
    />
  </div>
);
